require('../../modules/es7.object.values');
module.exports = require('../../modules/_core').Object.values;



//////////////////
// WEBPACK FOOTER
// /usr/local/lib/node_modules/react-scripts/node_modules/core-js/library/fn/object/values.js
// module id = 827
// module chunks = 0